import "./App.css";
import Home from "../src/Pages/home";
import About from "../src/Pages/about";
import Primarywing from "../src/Pages/primarywing";
import Howtoapply from "../src/Pages/howtoapply";
import ContactUs from "../src/Pages/contactUs";
import StaffDetails from "../src/Pages/staffDetails";
import MandatoryPublicDisclosure from "../src/Pages/mandatoryPublicDisclosure";
import NEP2020 from "../src/Pages/NEP2020";
import WallOfFame from "../src/Pages/wallOfFame";
import CBSEResult from "../src/Pages/CBSEResult";
import Olympiads from "../src/Pages/olympiads";
import SchoolBadgeHolder from "../src/Pages/schoolBadgeHolder";
import Philosophy from "../src/Pages/philosophy";
import Magazine from "../src/Pages/magazine";
import Admission from "../src/Pages/admission";
import AdmissionIIT from "../src/Pages/admissionIIT";
import Testimonial from "../src/Pages/testimonial";
import Partnership from "../src/Pages/partnership";
import Faculty from "../src/Pages/faculty";
import FortnightlyMagazine from "../src/Pages/fortnightlyMagazine";
import Carpediem from "../src/Pages/carpediem";
import Calender from "../src/Pages/calender";
import GloryOfNation from "../src/Pages/gloryOfNation";
import Mun from "../src/Pages/mun";
import VocationalClub from "../src/Pages/vocationalClub";
import VocationalClubmiddle from "../src/Pages/vocationalClubmiddle";
import VocationalClubPrimary from "../src/Pages/VocationalClubPrimary";
import SpocmacyColtoralHeritage from "../src/Pages/spocmacyColtoralHeritage";
import Gallery from "../src/Pages/Gallery";
import SubGallery from "../src/Pages/SubGallery";
import VideoGallery from "../src/Pages/VideoGallery";
import AwardsAcheivements from "../src/Pages/awardsAcheivements";
import StudentsAcheivements from "../src/Pages/studentsAcheivements";




import Curriculum from "../src/Pages/curriculum";
import SeniorWing from "../src/Pages/seniorWing";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MiddleWing from "./Pages/middleWing";
import Mathmatics from "./Pages/mathmatics";
import Physics from "./Pages/physics";
import Biology from "./Pages/biology";
import Language from "./Pages/language";
import Computer from "./Pages/computer";
import Robotics from "./Pages/robotics";
import Handonstudio from "./Pages/handonstudio";
import Psychology from "./Pages/psychology";
import CounselingSen from "./Pages/counseling-sen";
import Excursions from "./Pages/excursions";
import Library from "./Pages/library";
import FeildTrip from "./Pages/feildTrip";
import Astronomy from "./Pages/astronomy";
import Sports from "./Pages/sports";
import AcheivementInSports from "./Pages/acheivementInSports";
import Music from "./Pages/music";
import Dance from "./Pages/dance";
import VisualArts from "./Pages/visualArts";
import Houses from "./Pages/houses";
import Assembly from "./Pages/assembly";
import Booklist from "./Pages/booklist";
import Chemistry from "./Pages/chemistry";
import DirectorMessage from "./Pages/DirectorMessage";
import PrincipalMessage from "./Pages/PrincipalMessage";
import LeadershipTeam from "./Pages/leadershipTeam";
import Patrons from "./Pages/patrons";
import AdvisoryBoard from "./Pages/advisoryBoard";
import SchoolStrength from "./Pages/schoolStrength";
import News from "./Pages/news";
import NewsInner from "./Pages/newsInner";
import Circular from "./Pages/circular";
import FeeStructure from "./Pages/feestructure";
import Prospectus from "./Pages/prospectus";
import SchoolSchedule from "./Pages/schoolSchedule";
import Transport from "./Pages/transport";
import BusRoute from "./Pages/busRoute";
import SpecialEdu from "./Pages/specialEdu";
import Bondingwithparents from "./Pages/bondingwithparents";
import CareerCounselling from "./Pages/careerCounselling";
import Schoolprofile from "./Pages/schoolprofile";
import Mealmenu from "./Pages/mealmenu";
import Tc from "./Pages/tc";
import Vistas from "./Pages/vistas";
import CounsellingVistas from "./Pages/counsellingVistas";
import CounsellingSessionVistas from "./Pages/counsellingSessionVistas";
import UpcomingevtVistas from "./Pages/upcomingevtVistas";
import UpdateVistas from "./Pages/updateVistas";
import ConnectVistas from "./Pages/connectVistas";
import SpotligvhtVistas from "./Pages/spotlightVistas";
import CuetVistas from "./Pages/cuetVistas";
import Jee from "./Pages/jee";
import Neet from "./Pages/neet";
import CyberSecurity from "./Pages/cyberSecurity";
import Videos from "./Pages/Videos";
import StoryBooks from "./Pages/StoryBooks";
import CareersOpenings from "./Pages/careers-openings";
import DigitalDreams from "./Pages/DigitalDreams";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/primarywing" element={<Primarywing />}></Route>
          <Route path="/howtoapply" element={<Howtoapply />}></Route>
          <Route path="/contactUs" element={<ContactUs />}></Route>
          <Route path="/staffDetails" element={<StaffDetails />}></Route>
          <Route
            path="/mandatoryPublicDisclosure"
            element={<MandatoryPublicDisclosure />}></Route>
          <Route path="/NEP2020" element={<NEP2020 />}></Route>
          <Route path="/wallOfFame" element={<WallOfFame />}></Route>
          <Route path="/CBSEResult" element={<CBSEResult />}></Route>
          <Route path="/olympiads" element={<Olympiads />}></Route>
          <Route
            path="/schoolBadgeHolder"
            element={<SchoolBadgeHolder />}></Route>
          <Route path="/careers-openings" element={<CareersOpenings />}></Route>
          <Route path="/philosophy" element={<Philosophy />}></Route>
          <Route path="/magazine" element={<Magazine />}></Route>
          <Route path="/admission" element={<Admission />}></Route>
          <Route path="/admissionIIT" element={<AdmissionIIT />}></Route>
          <Route path="/testimonial" element={<Testimonial />}></Route>
          <Route path="/partnership" element={<Partnership />}></Route>
          <Route path="/faculty" element={<Faculty />}></Route>
          <Route
            path="/fortnightlyMagazine"
            element={<FortnightlyMagazine />}></Route>
          <Route path="/carpediem" element={<Carpediem />}></Route>
          <Route path="/calender" element={<Calender />}></Route>
          <Route path="/GloryOfNation" element={<GloryOfNation />}></Route>
          <Route path="/Mun" element={<Mun />}></Route>
          <Route path="/vocationalClub" element={<VocationalClub />}></Route>
          <Route
            path="/spocmacyColtoralHeritage"
            element={<SpocmacyColtoralHeritage />}></Route>
          <Route
            path="/vocationalClubmiddle"
            element={<VocationalClubmiddle />}></Route>
          <Route
            path="/VocationalClubPrimary"
            element={<VocationalClubPrimary />}></Route>
          <Route path="/gallery" element={<Gallery />}></Route>
          <Route path="/SubGallery" element={<SubGallery />}></Route>
          <Route path="/VideoGallery" element={<VideoGallery />}></Route>
          <Route
            path="/awardsAcheivements"
            element={<AwardsAcheivements />}></Route>

<Route
            path="/studentsAcheivements"
            element={<StudentsAcheivements />}></Route>




          <Route path="/curriculum" element={<Curriculum />}></Route>
          <Route path="/seniorWing" element={<SeniorWing />}></Route>
          <Route path="/middleWing" element={<MiddleWing />}></Route>
          <Route path="/mathmatics" element={<Mathmatics />}></Route>
          <Route path="/biology" element={<Biology />}></Route>
          <Route path="/physics" element={<Physics />}></Route>
          <Route path="/language" element={<Language />}></Route>
          <Route path="/computer" element={<Computer />}></Route>
          <Route path="/robotics" element={<Robotics />}></Route>
          <Route path="/hands-on-studio" element={<Handonstudio />}></Route>
          <Route path="/psychology" element={<Psychology />}></Route>
          <Route path="/Counseling-sen" element={<CounselingSen />}></Route>
          <Route path="/excursions" element={<Excursions />}></Route>
          <Route path="/library" element={<Library />}></Route>
          <Route path="/feildTrip" element={<FeildTrip />}></Route>
          <Route path="/astronomy" element={<Astronomy />}></Route>
          <Route path="/sports" element={<Sports />}></Route>
          <Route
            path="/acheivementInSports"
            element={<AcheivementInSports />}></Route>
          <Route path="/music" element={<Music />}></Route>
          <Route path="/dance" element={<Dance />}></Route>
          <Route path="/visualArts" element={<VisualArts />}></Route>
          <Route path="/houses" element={<Houses />}></Route>
          <Route path="/assembly" element={<Assembly />}></Route>
          <Route path="/booklist" element={<Booklist />}></Route>
          <Route path="/chemistry" element={<Chemistry />}></Route>
          <Route
            path="/DirectorMessage"
            element={<DirectorMessage />}></Route>
          <Route
            path="/PrincipalMessage"
            element={<PrincipalMessage />}></Route>
          <Route path="/leadershipTeam" element={<LeadershipTeam />}></Route>
          <Route path="/patrons" element={<Patrons />}></Route>
          <Route path="/advisoryBoard" element={<AdvisoryBoard />}></Route>
          <Route path="/schoolStrength" element={<SchoolStrength />}></Route>
          <Route path="/news" element={<News />}></Route>
          <Route path="/newsInner" element={<NewsInner />}></Route>
          <Route path="/circular" element={<Circular />}></Route>
          <Route path="/feestructure" element={<FeeStructure />}></Route>
          <Route path="/Prospectus" element={<Prospectus />}></Route>
          <Route path="/schoolSchedule" element={<SchoolSchedule />}></Route>
          <Route path="/transport" element={<Transport />}></Route>
          <Route path="/busRoute" element={<BusRoute />}></Route>
          <Route path="/specialEdu" element={<SpecialEdu />}></Route>
          <Route
            path="/bondingwithparents"
            element={<Bondingwithparents />}></Route>
          {/* <Route path="/careerCounselling" element={<CareerCounselling />}></Route> */}
          <Route path="/schoolprofile" element={<Schoolprofile />}></Route>
          <Route path="/mealmenu" element={<Mealmenu />}></Route>
          <Route path="/tc" element={<Tc />}></Route>
          <Route path="/vistas" element={<Vistas />}></Route>
          <Route
            path="/counselling-vistas"
            element={<CounsellingVistas />}></Route>
          <Route
            path="/counselling-session-vistas"
            element={<CounsellingSessionVistas />}></Route>
          <Route
            path="/upcomingevt-vistas"
            element={<UpcomingevtVistas />}></Route>
          <Route path="/update-vistas" element={<UpdateVistas />}></Route>
          <Route
            path="/spotlight-vistas"
            element={<SpotligvhtVistas />}></Route>
          <Route path="/connect-vistas" element={<ConnectVistas />}></Route>
          <Route path="/cuetVistas" element={<CuetVistas />}></Route>
          <Route path="/jee" element={<Jee />}></Route>
          <Route path="/neet" element={<Neet />}></Route>
          <Route path="/cyberSecurity" element={<CyberSecurity />}></Route>
          <Route
            path="/digitaldreams"
            element={<DigitalDreams></DigitalDreams>}></Route>
          <Route path="/Videos" element={<Videos />}></Route>
          <Route path="/StoryBooks" element={<StoryBooks />}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
